import { Controller } from "@hotwired/stimulus"

// Pedido manual com vários itens: adiciona/remove linhas e, ao escolher um
// produto salvo numa linha, pré-preenche nome/preço/peso daquela linha (os
// campos seguem editáveis — o produto é só um ponto de partida).
export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    // Índice pros novos itens continuar depois dos já renderizados (0..n-1).
    this.counter = this.rowsTarget.children.length
  }

  add(event) {
    if (event) event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, this.counter++)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-order-item-row]")
    if (row) row.remove()
    if (this.rowsTarget.children.length === 0) this.add()
  }

  // Preenche só a linha onde o produto foi escolhido.
  fill(event) {
    const opt = event.target.selectedOptions[0]
    if (!opt || !opt.value) return
    const row = event.target.closest("[data-order-item-row]")
    if (!row) return

    const set = (role, val) => {
      const el = row.querySelector(`[data-role="${role}"]`)
      if (el && val != null && val !== "") el.value = val
    }
    set("name", opt.dataset.name)
    set("price", opt.dataset.priceBrl)
    set("weight", opt.dataset.weight)
  }
}
